import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  consultarReportes: ["payload"],
  consultarReportesLoading: null,
  consultarReportesSuccess: ["consultarReportesData"],
  consultarReportesFailure: ["consultarReportesError"],

  exportarReportesExcel: ["payload"],
  exportarReportesExcelLoading: null,
  exportarReportesExcelSuccess: ["exportarReportesExcelData"],
  exportarReportesExcelFailure: ["exportarReportesExcelError"],

  limpiarReportes: null
});

export { Types };

export default Creators;
